export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>
        SEILAN — South East Idaho Local Ads Network · Built in Pocatello, ID · A product of{" "}
        <a href="https://moatit.com">MOATiT LLC</a>
      </p>
      <p>
        <a href="https://seilan.us">seilan.us</a>
      </p>
    </footer>
  );
}
